/* eslint-disable unicorn/filename-case -- TODO rename later */
import { authConfig } from "@istari-frontend/auth";
import { Toaster } from "@istari-frontend/ui";
import { SidebarProvider } from "@istari-frontend/ui";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "react-oidc-context";
import { Outlet } from "react-router";

import "./App.css";
import { RemotesOperationsProvider } from "./contexts/remotes-operations.provider";
import { useFontSize } from "./hooks/use-font-size";
import AuthErrorBoundary from "./pages/Authentication/AuthErrorBoundary";

function App() {
  useFontSize();

  return (
    <AuthProvider {...authConfig}>
      <AuthErrorBoundary>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="istari-theme-preference">
          <SidebarProvider defaultOpen={true}>
            <RemotesOperationsProvider>
              <Outlet />
            </RemotesOperationsProvider>
            <Toaster />
          </SidebarProvider>
        </ThemeProvider>
      </AuthErrorBoundary>
    </AuthProvider>
  );
}

export default App;
